import { clientApi } from 'shared/api/clientApi'
import { Hotel } from 'shared/api/tours/search'
import {
  AboutTourObject,
  HotelDetailsParams,
  HotelRoomRequestParams,
  HotelRoomResponse,
} from 'shared/api/tours/tour-detail/model'
import { Response } from 'shared/models/general'

export const HotelDetailApi = {
  getHotelDetails: (data: HotelDetailsParams) =>
    clientApi.post<Response<Hotel>>(`tours/hotels/detail`, data),

  getHotelDetailsBySharingCode: (sharingCode: string) =>
    clientApi.get<Response<Hotel>>(
      `tours/andromeda/shared-data?code=${sharingCode}`,
    ),

  getAboutTour: () =>
    clientApi.get<Response<Array<AboutTourObject>>>('tours/hotels/about-tour'),

  getHotelRooms: (data: HotelRoomRequestParams) =>
    clientApi.post<Response<HotelRoomResponse>>(
      `tours/hotels/detail/tours`,
      data,
    ),
}
